module.exports = __webpack_public_path__ + "images/emoji/cow.ba29266237a2410659cf.png";